import React, { useEffect, useState } from 'react';
import Loader from '../../components/ui/Loader/Loader';
import { useSelector } from 'react-redux';
import Status from '../../components/ui/Status';
const MySites = (props) => {
    const user_sites           =   useSelector(state => state.app.user_sites);

    const [userDetailData, setUserDetailData] = useState(null)
    const [linkedSitesList, setlinkedSitesList] = useState([])
    const [iam_user_sites, setIam_user_sites] = useState([])

    useEffect(() => {
        initilaizeData(props)
    }, [])

    const initilaizeData = (pr) => {
        setUserDetailData(pr.userDetailData)
        setlinkedSitesList(user_sites && user_sites.length > 0 && pr.userDetailData && pr.userDetailData.site_ids && pr.userDetailData.site_ids.length > 0 ? user_sites.filter(site => pr.userDetailData.site_ids.includes(site.id) ? true : false) : [])
        setIam_user_sites(user_sites ? user_sites.map((s) => { return { value: s.id, label: `${s.site_name} (${s.site_code})` } }) : [])
    }
    const siteDetailJsx = () => {
        let detail = userDetailData;
        
        return (
            <>
                <div className="tab_content_wrapper"><span className="content_heading">Sites</span>
                </div>
                <div className='row'>
                    <div className='col-sm-9'>
                        <table className=" table table-hover table-bordered  table-responsive bg-white my-2 table-sm ">
                            <thead className="table-secondary">
                                <tr className="text-center">
                                    <th style={{ width: "10%" }} className="text-center">S.No</th>
                                    <th style={{ width: "25%" }} className="text-center">Site Code</th>
                                    <th className="text-start">Site Name</th>
                                </tr>
                            </thead>

                            <tbody>
                                {linkedSitesList && linkedSitesList.length > 0
                                    ? (linkedSitesList.map((t, k) => {
                                        let user_sites = [];
                                        user_sites = iam_user_sites && iam_user_sites.length > 0 ? iam_user_sites.map(site => site.value) : [];
                                        return (<tr key={k}>
                                            <td className='text-center'>{k + 1}</td>
                                            <td className='text-center'>{(t?.site_code || "-")}</td>
                                            <td>{(t?.site_name || "-")}</td>
                                        </tr>);
                                    }))
                                    : (<tr><td colSpan="2" className="text-center">No Records</td></tr>)

                                }
                            </tbody>

                        </table>
                    </div>
                    <div className='col-sm-3'>
                        <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                            <tbody>
                                <tr>
                                    <th className="text-center"><img src={detail?.image} className="img_fluid" alt="profile_img" style={{ height: "120px" }} /> </th>
                                </tr>
                                <tr>
                                    <th>Name :  {detail?.full_name ? detail.full_name : "-"} </th>
                                </tr>
                                <tr>
                                    <th>Status :  {detail?.status ? <Status color={detail.status_color_code}>{detail.status_text}</Status> : "-"} </th>
                                </tr>
                                <tr>
                                    <th>2FA :  {detail?.enable_2fa === 'Y' ?
                                        <Status color="green">Enabled</Status> :
                                        <Status color="red">Disabled</Status>}
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        )
    }
    return (<>
         {siteDetailJsx()}
    </>
    );
};


export default MySites;


